"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _index = _interopRequireDefault(require("../index"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var EmailSignupModal = function EmailSignupModal(_ref) {
  var timeout = _ref.timeout,
    addressBookId = _ref.addressBookId,
    image = _ref.image,
    text = _ref.text,
    title = _ref.title,
    mobileLink = _ref.mobileLink,
    ignoreCookie = _ref.ignoreCookie,
    onClose = _ref.onClose,
    subscribeButtonText = _ref.subscribeButtonText,
    successMessage = _ref.successMessage,
    companyId = _ref.companyId;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    on = _useState2[0],
    setOn = _useState2[1];
  (0, _react.useEffect)(function () {
    if (ignoreCookie) {
      setOn(true);
    } else if (_jsCookie["default"].get('signup_modal') === undefined) {
      if (timeout) setTimeout(function () {
        return setOn(true);
      }, timeout);
      _jsCookie["default"].set('signup_modal', true, {
        expires: 1
      });
    }
  }, []);
  var toggle = function toggle() {
    setOn(!on);
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_index["default"], {
    style: {
      width: 'var(--max-width-md)',
      minWidth: 'unset'
    },
    template: "Signup",
    mobileLink: mobileLink,
    addressBookId: addressBookId,
    title: title,
    text: text,
    toggle: toggle,
    on: on,
    image: image,
    subscribeButtonText: subscribeButtonText,
    successMessage: successMessage,
    companyId: companyId
  });
};
EmailSignupModal.propTypes = {
  timeout: _propTypes["default"].number,
  addressBookId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  image: _propTypes["default"].object,
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  mobileLink: _propTypes["default"].string,
  ignoreCookie: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  subscribeButtonText: _propTypes["default"].string,
  successMessage: _propTypes["default"].string,
  companyId: _propTypes["default"].number
};
EmailSignupModal.defaultProps = {
  title: 'Sign up now',
  text: 'Subscribe to our newsletter, we promise not to spam you.',
  image: {
    url: 'https://assets.theyachtweek.com/wp-content/uploads/2020/08/signup-default.jpg',
    alt: 'Image'
  },
  ignoreCookie: false,
  onClose: function onClose() {},
  subscribeButtonText: 'Subscribe',
  successMessage: 'You\'re signed up!'
};
var _default = exports["default"] = EmailSignupModal;